import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatLanguageCode } from 'i18n/options';
import config from 'utils/config';
import { OPTIONAL, REQUIRED } from 'utils/asset/completionModes';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import useForm from 'hooks/useForm';
export function usePlaylistForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    playlist = _ref.playlist,
    initialTopics = _ref.initialTopics,
    initialOwner = _ref.initialOwner;
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.i18n;
  var isCreateMode = !(playlist !== null && playlist !== void 0 && playlist.id);
  var defaultLocale = formatLanguageCode(i18n.language) || null;
  var hasPlaylistNumbering = playlist ? playlist.hasPlaylistNumbering : config.playlistNumbering;
  function checkIfBadgeImageIdWasChanged(defaultValue, newValue) {
    var _playlist$badge;
    var initialImage = defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.imageId;
    var newImage = newValue === null || newValue === void 0 ? void 0 : newValue.imageId;
    var wasInitialBadgeDeleted = (playlist === null || playlist === void 0 || (_playlist$badge = playlist.badge) === null || _playlist$badge === void 0 ? void 0 : _playlist$badge.isDeleted) || false;
    var isNewBadgeDeleted = newValue === null || newValue === void 0 ? void 0 : newValue.isDeleted;
    if (!initialImage && !newImage) {
      return false;
    }
    return initialImage !== newImage || wasInitialBadgeDeleted && !isNewBadgeDeleted && !!newValue;
  }
  var playlistForm = useForm({
    fields: {
      name: {
        getDefaultValue: function getDefaultValue() {
          return (playlist === null || playlist === void 0 ? void 0 : playlist.name) || '';
        },
        required: true
      },
      description: {
        getDefaultValue: function getDefaultValue() {
          return (playlist === null || playlist === void 0 ? void 0 : playlist.description) || '';
        }
      },
      tags: {
        getDefaultValue: function getDefaultValue() {
          return (playlist === null || playlist === void 0 ? void 0 : playlist.tags) || [];
        }
      },
      thumbnailId: {
        getDefaultValue: function getDefaultValue() {
          return (playlist === null || playlist === void 0 ? void 0 : playlist.thumbnailId) || null;
        }
      },
      locale: {
        getDefaultValue: function getDefaultValue() {
          return (playlist === null || playlist === void 0 ? void 0 : playlist.locale) || defaultLocale;
        }
      },
      topics: {
        getDefaultValue: function getDefaultValue() {
          return initialTopics || (playlist === null || playlist === void 0 ? void 0 : playlist.topics) || [];
        }
      },
      openInNewWindow: {
        getDefaultValue: function getDefaultValue() {
          return false;
        }
      },
      memberContributions: {
        getDefaultValue: function getDefaultValue() {
          return (playlist === null || playlist === void 0 ? void 0 : playlist.allow_member_contributions) || false;
        }
      },
      badge: {
        getDefaultValue: function getDefaultValue() {
          return playlist === null || playlist === void 0 ? void 0 : playlist.badge;
        },
        getWasChanged: checkIfBadgeImageIdWasChanged
      },
      externalRefId: {
        getDefaultValue: function getDefaultValue() {
          return (playlist === null || playlist === void 0 ? void 0 : playlist.externalRefId) || '';
        }
      },
      displayContentNumbers: {
        getDefaultValue: function getDefaultValue() {
          return hasPlaylistNumbering;
        }
      },
      completionMode: {
        getDefaultValue: function getDefaultValue() {
          if (playlist && 'optional' in playlist && playlist.optional) {
            return OPTIONAL;
          } else {
            return REQUIRED;
          }
        }
      },
      owner: {
        getDefaultValue: function getDefaultValue() {
          if (isCreateMode && hasPrivilege(PLAYLIST_WRITE)) {
            return initialOwner || null;
          }
          return (playlist === null || playlist === void 0 ? void 0 : playlist.owner) || null;
        },
        getWasChanged: function getWasChanged(defaultValue, newValue) {
          var defaultOwnerId = (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.id) || null;
          var newOwnerId = (newValue === null || newValue === void 0 ? void 0 : newValue.id) || null;
          return defaultOwnerId !== newOwnerId;
        }
      }
    }
  });
  var reset = playlistForm.reset;
  useEffect(function () {
    // Sync form data if playlist data is updated
    if (playlist) {
      reset({
        keepUserValues: true
      });
    }
  }, [playlist, reset]);
  return playlistForm;
}